import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "chevron"]

  toggle(event) {
    event.stopPropagation()
    const isHidden = this.menuTarget.classList.contains("hidden")
    if (isHidden) {
      this.menuTarget.classList.remove("hidden")
      this.chevronTarget.style.transform = "rotate(180deg)"
    } else {
      this.menuTarget.classList.add("hidden")
      this.chevronTarget.style.transform = ""
    }
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      this.chevronTarget.style.transform = ""
    }
  }
}
